import { pipe } from "fp";

import React from "react";

import * as Context from "~/Context";
import * as Data from "~/Data";
import { Component as LinkComponent } from "~/Link";
import { Remote } from "~/Remote";
import { Time } from "~/Time";
import * as WorkCode from "~/WorkCode";

import * as Request from "./Request";

export { Request };

export type Job = {
  readonly id: string;
  readonly name?: string;
  readonly workCodes?: readonly WorkCode.WorkCode[];
};

export const useHREF = (): string =>
  `${Context.useBaseURL()}/#/home/company-admin/jobs`;

export const use = (): Data.Remote<readonly Job[]> =>
  Remote.Query.use(Request.Query.key(), Request.Query.request(), {
    keepPreviousData: true,
    staleTime: Time.Duration.minutes(30).duration,
  });

export const useWhenAvailable = () => pipe(use(), Remote.toUndefined);

export const useName = (job: Data.Reference.Reference): string | undefined =>
  pipe(useWhenAvailable(), (jobs) =>
    pipe(
      jobs && jobs.find((j) => j.id === job.id),
      (job) => (job ? job.name : undefined) ?? undefined
    )
  );

export const asDescription =
  (job?: Data.Reference.Reference) =>
  (jobs: readonly Job[] | undefined): string =>
    jobs
      ? pipe(
          jobs.find((j) => job && j.id === job.id),
          (job) => (job ? job.name : "") ?? ""
        )
      : "";

export namespace State {
  export type State = Data.Store.Store<Job>;
  export const initial = (): State => Data.Store.initial();
}

export namespace Link {
  type Props = React.HTML<"a"> & {
    readonly job: Data.Reference.Reference;
    readonly href?: undefined;
  };

  export const Component: React.Fn<Props> = ({ job, ...props }) => (
    <LinkComponent href={useHREF()} {...props}>
      {useName(job) || job.id}
    </LinkComponent>
  );
}
